import { render, staticRenderFns } from "./PointNetridecashTechcoinFormSet.vue?vue&type=template&id=432b049c"
import script from "./PointNetridecashTechcoinFormSet.vue?vue&type=script&lang=js"
export * from "./PointNetridecashTechcoinFormSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports